<template>
  <!-- 디자인 시스템: 범용 텍스트 인풋. 테마는 Vuetify Themeable 자동 상속(v-app/$vuetify.theme.dark·v-theme-provider),
       dark/light prop은 강제 오버라이드. v-model 지원, Enter는 @enter, 우측 append 슬롯(버튼 등). -->
  <div class="app-input" :class="{ 'app-input--light': lightMode }" :style="rootStyle">
    <span v-if="$slots.prepend" class="app-input__prepend"><slot name="prepend"></slot></span>
    <input
      ref="field"
      class="app-input__field"
      :type="type"
      :value="value"
      :placeholder="placeholder"
      @input="$emit('input', $event.target.value)"
      @keydown.enter="onEnterKey"
      @keydown.esc="$emit('esc')"
    />
    <span v-if="$slots.append" class="app-input__append"><slot name="append"></slot></span>
  </div>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";

export default {
  name: "AppInput",
  mixins: [Themeable], // dark/light prop + isDark(컨텍스트 상속) 제공
  props: {
    value: { type: [String, Number], default: "" },
    placeholder: { type: String, default: "" },
    type: { type: String, default: "text" },
    // 박스 높이(px) — AppSelect와 동일 기본값(28)으로 인라인 정렬 맞춤
    height: { type: [Number, String], default: 28 },
  },
  computed: {
    lightMode() {
      return !this.isDark;
    },
    rootStyle() {
      const h = isNaN(this.height) ? this.height : `${this.height}px`;
      return { "--app-input-h": h };
    },
  },
  methods: {
    // 외부에서 포커스 (다이얼로그 오토포커스 등). select=true면 기존 값 전체 선택(바로 덮어쓰기).
    focus({ select = false } = {}) {
      const el = this.$refs.field;
      if (!el) return;
      el.focus();
      if (select) el.select();
    },
    // 한글 IME 조합 중(Enter가 조합 확정용)엔 무시 → 중복/미완성 값 방지 (Vue 알려진 이슈).
    //  값은 prop(value)이 아니라 실제 input.value로 emit해 최신값 보장.
    onEnterKey(e) {
      if (e.isComposing || e.keyCode === 229) return;
      this.$emit("enter", e.target.value);
    },
  },
};
</script>

<style scoped>
.app-input {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  box-sizing: border-box;
  height: var(--app-input-h, 28px); /* 고정 높이 → AppSelect와 인라인 정렬 일치 */
  padding: 0 6px 0 10px;
  border-radius: 7px;
  background: #23232f;
  border: 1px solid #2f2f3d;
  transition: border-color 0.15s ease;
}
.app-input:focus-within {
  border-color: rgba(145, 85, 253, 0.55);
}
.app-input__field {
  flex: 1;
  min-width: 0;
  background: transparent;
  border: none;
  outline: none;
  color: #e6e6ee;
  font-size: 13px;
}
.app-input__field::placeholder {
  color: #6b6b7d;
}
.app-input__prepend,
.app-input__append {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

/* ── light theme ── */
.app-input--light {
  background: #f4f3f8;
  border-color: #e2e0ec;
}
.app-input--light:focus-within {
  border-color: rgba(124, 77, 255, 0.5);
  background: #fff;
}
.app-input--light .app-input__field {
  color: #37324a;
}
.app-input--light .app-input__field::placeholder {
  color: #a29cb8;
}
</style>
